// Rebuilt in-campaign UI ("graphic novel"). Теперь ВКЛючён по умолчанию для всех:
// активная игра рендерится новым gn-UI, а этап подготовки кампании (пока не
// переделан) остаётся на легаси — переключение делает GnCampaignShell по
// setupStage. Escape-hatch для отладки: ?gnui=0 отключает gn (и запоминается).

const KEY = "citychronicle.gn.ui";

export function gnUiEnabled(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has("gnui")) {
      const on = params.get("gnui") !== "0";
      window.localStorage.setItem(KEY, on ? "1" : "0");
      return on;
    }
    // По умолчанию ВКЛ; выключается только явным ?gnui=0 (сохранённым в localStorage).
    return window.localStorage.getItem(KEY) !== "0";
  } catch {
    return true;
  }
}
